<template>
    <div ref="container" @mouseenter="pause" @mouseleave="unpause">
        <transition name="slide-in-left">
            <template v-for="(slide, i) in slides">
                <div :key="i" v-if="i === value">
                    <slot :slide="slide"></slot>
                </div>
            </template>
        </transition>
    </div>
</template>

<script>
import {isVisible} from "../../core/utils/visibility";
import {debounce} from "../../core/utils/debounce";

export default {
    name: "carousel",
    props: {
        slides: [Array, Number],
        value: Number,
        timeout: {
            type: Number,
            default: 7000
        }
    },
    data: () => ({
        paused: false,
        timer: null
    }),
    methods: {
        pause() {
            if (!this.paused) {
                this.paused = true
            }
        },
        unpause() {
            if (this.paused) {
                this.paused = false
            }
        },
        carousel() {
            // continue when un-paused
            if (!this.paused) {
                const newIndex = this.value + 1
                const index = newIndex === this.slides.length ? 0 : newIndex

                this.$emit('input', index)
            }
        },
        contentCarousel() {
            this.timer = setInterval(this.carousel, this.timeout)
        },
        slideScreenContext: debounce(function () {
            if (isVisible(this.$refs.container)) this.unpause()
            else this.pause()
        })
    },
    created() {
        if (this.slides.length > 1) {
            this.contentCarousel()
            window.addEventListener('scroll', this.slideScreenContext)
            window.addEventListener('resize', this.slideScreenContext)
        }
    },
    beforeDestroy() {
        if (this.slides.length > 1) {
            clearInterval(this.timer)
            window.removeEventListener('scroll', this.slideScreenContext)
            window.removeEventListener('resize', this.slideScreenContext)
        }
    }
}
</script>

